// extracted by mini-css-extract-plugin
export default {"tabs_box":"index_tabs_box_aKGgl","hairlines":"index_hairlines_umFpT","tabs":"index_tabs_OTb8h","mask":"index_mask_v4I6p"};